import React from 'react';
import { AlertTriangle, CheckCircle2, MessageCircle } from 'lucide-react';
import { Box } from 'src/ui/box';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/ui/table';
import { cn } from 'src/utils/@/lib/utils';

const cellClass =
  'h-auto border border-solid border-[#D7D7DD] px-4 py-[5px] leading-none';

export default function InspectionTable(props) {
  const { rows, title } = props;

  const newRows = rows.map(({ id, name, grey, green, yellow, red, fixed, comments }) => ({
    id,
    name,
    grey,
    green,
    yellow,
    red,
    fixed,
    comments,
  }));

  const visibleRows = newRows.filter(
    (row) => row.fixed || row.green || row.red || row.yellow
  );

  if (visibleRows.length === 0) return null;

  return (
    <Table className="border-collapse">
      <TableHeader>
        <TableRow className="bg-[#F4FEEC] hover:bg-[#F4FEEC]">
          <TableHead colSpan={2} className={cn(cellClass, 'w-[30%] text-left')}>
            <span className="text-sm font-semibold text-black">{title}</span>
          </TableHead>
          <TableHead className={cn(cellClass, 'w-[5%] text-center')}>
            <Box className="flex flex-col items-center justify-center">
              <span className="text-xs text-black">Passed</span>
              <CheckCircle2 className="text-green-600 mt-4" />
            </Box>
          </TableHead>
          <TableHead className={cn(cellClass, 'w-[5%] text-center')}>
            <Box className="flex flex-col items-center justify-center">
              <span className="text-xs text-black">Fixed / Replaced</span>
              <CheckCircle2 className="text-blue-800 mt-4" />
            </Box>
          </TableHead>
          <TableHead className={cn(cellClass, 'w-[5%] text-center')}>
            <Box className="flex flex-col items-center justify-center">
              <span className="text-12 text-black">Needs Attention</span>
              <AlertTriangle className="text-amber-500 mt-4" />
            </Box>
          </TableHead>
          <TableHead className={cn(cellClass, 'w-[5%] text-center')}>
            <Box className="flex flex-col items-center justify-center">
              <span className="text-12 text-black">Needs Work</span>
              <AlertTriangle className="text-destructive mt-4" />
            </Box>
          </TableHead>
          <TableHead className={cn(cellClass, 'w-[25%] text-center')}>
            <Box className="flex flex-col items-center justify-center">
              <span className="text-12 text-black">Comments</span>
              <MessageCircle className="mt-4" />
            </Box>
          </TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {visibleRows.map((row, index) => (
          <TableRow key={row.id}>
            <TableCell className={cellClass}>
              <span className="text-black">{index + 1}</span>
            </TableCell>

            <TableCell className={cn(cellClass, 'text-left')}>
              <span className="text-12 text-black">{row.name}</span>
            </TableCell>

            <TableCell className={cn(cellClass, 'text-center')}>
              {row.green && (
                <div className="flex justify-center items-center">
                  <CheckCircle2 className="text-green-600" />
                </div>
              )}
            </TableCell>

            <TableCell className={cn(cellClass, 'text-center')}>
              {row.fixed && (
                <div className="flex justify-center items-center">
                  <CheckCircle2 className="text-blue-800" />
                </div>
              )}
            </TableCell>

            <TableCell className={cn(cellClass, 'text-center')}>
              {row.yellow && (
                <div className="flex justify-center">
                  <AlertTriangle className="text-amber-500" />
                </div>
              )}
            </TableCell>

            <TableCell className={cn(cellClass, 'text-center')}>
              {row.red && (
                <div className="flex justify-center">
                  <AlertTriangle className="text-destructive" />
                </div>
              )}
            </TableCell>

            <TableCell className={cn(cellClass, 'text-center')}>
              {row.comments?.length > 0 && (
                <div className="flex justify-center flex-col">
                  {row.comments.map((comment, index) => (
                    <div key={index} className="flex-col flex justify-start items-start">
                      <span className="text-justify">{comment ?? ''}</span>
                    </div>
                  ))}
                </div>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
